import { render, staticRenderFns } from "./reply-add-or-update.vue?vue&type=template&id=63fa354f&scoped=true&"
import script from "./reply-add-or-update.vue?vue&type=script&lang=js&"
export * from "./reply-add-or-update.vue?vue&type=script&lang=js&"
import style0 from "./reply-add-or-update.vue?vue&type=style&index=0&id=63fa354f&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63fa354f",
  null
  
)

export default component.exports